const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Uploaded images are stored as "/api/files/{id}/download" — resolve them for <img>. */
export const imageSrc = (value) => {
  if (!value) return null;
  const ref = String(value).trim();
  if (ref.startsWith("/api/")) return `${BACKEND}${ref}`;
  return ref;
};
